import {
  SegmentedGroup,
  SegmentedGroupItem,
} from '@repo/ui/components/segmented-group'
import { useTranslate } from '../../hooks'
import type { AdvancedTradeBoxToggleProps } from './advanced-trade-box.types'

export const AdvancedTradeBoxToggle = ({
  value,
  onChange,
}: AdvancedTradeBoxToggleProps) => {
  const { t } = useTranslate()

  return (
    <SegmentedGroup
      value={value}
      onValueChange={onChange}
      size='sm'
      className='w-full mb-md'
      defaultValue='amount'
    >
      <SegmentedGroupItem value='amount' className='flex-1'>
        {t('common_amount')}
      </SegmentedGroupItem>
      <SegmentedGroupItem value='total' className='flex-1'>
        {t('order_total')}
      </SegmentedGroupItem>
    </SegmentedGroup>
  )
}
